import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow44_1Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow44_1 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("WASTE_PROCESSES_PREPARING_FINAL_TREATMENT") || "Waste processes preparing for final treatment"}
        subDescription={t("WASTE_PROCESSES_PREPARING_FINAL_TREATMENT_DESC") || "These are the steps that prepare waste for its last treatment stage, such as sorting, compacting, drying, or pre-shredding. Their purpose is to make the waste suitable for safe handling, transport, or final disposal."}
        isNormal={true}
        number={"44.1"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-44-1-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow44_1Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow44_1;

